const fi = {
    nav: {
      home: "Etusivu",
      browse: "Selaa häitä",
      dashboard: "Hallintapaneeli",
      messages: "Viestit",
      profile: "Profiili",
      login: "Kirjaudu",
      register: "Rekisteröidy",
      logout: "Kirjaudu ulos",
      admin: "Ylläpito",
      faq: "UKK",
      about: "Meistä",
      contact: "Yhteystiedot",
      pricing: "Hinnat",
      howItWorks: "Näin se toimii",
    },
    auth: {
      login: {
        title: "Tervetuloa takaisin",
        email: "Sähköposti",
        password: "Salasana",
        button: "Kirjaudu",
        noAccount: "Ei tiliä?",
        register: "Rekisteröidy nyt",
      },
      register: {
        title: "Luo tili",
        name: "Koko nimi",
        email: "Sähköposti",
        password: "Salasana",
        role: "Haluan...",
        roleHost: "Järjestää häät",
        roleGuest: "Osallistua häihin",
        terms: "Hyväksyn käyttöehdot ja tietosuojakäytännön",
        button: "Rekisteröidy",
        hasAccount: "Onko sinulla jo tili?",
        login: "Kirjaudu nyt",
      },
    },
  review: {
    title: "Write a Review",
    description: "Share your experience with",
    ratingLabel: "How would you rate your experience?",
    rating1: "Poor",
    rating2: "Fair",
    rating3: "Good",
    rating4: "Very Good",
    rating5: "Excellent",
    commentLabel: "Your Review",
    optional: "optional",
    commentPlaceholder: "Tell others about your experience...",
    for: "Review for",
    submit: "Submit Review",
    success: "Review submitted successfully!",
    error: "Failed to submit review",
    selectRating: "Please select a rating",
    noReviews: "No reviews yet",
    received: "Reviews Received",
    averageRating: "Average Rating",
    writeReview: "Write Review",
    reviewed: "Reviewed",
    completedWedding: "This wedding has been completed. You can now write a review.",
  },

    common: {
      loading: "Ladataan...",
      error: "Tapahtui virhe",
      success: "Onnistui",
      save: "Tallenna",
      cancel: "Peruuta",
      delete: "Poista",
      edit: "Muokkaa",
      back: "Takaisin",
      next: "Seuraava",
      language: "Kieli",
      currency: "Valuutta",
      search: "Haku",
      filter: "Suodata",
      all: "Kaikki",
      none: "Ei mitään",
      yes: "Kyllä",
      no: "Ei",
    },
    footer: {
      about: "Meistä",
      privacy: "Tietosuoja",
      terms: "Ehdot",
      contact: "Yhteystiedot",
      copyright: "© 2024 WEDVAYA. Kaikki oikeudet pidätetään.",
    },
  };

export default fi;
